var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletIco({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8C14.4477 8 14 8.4477 14 9V15C14 15.5523 14.4477 16 15 16H21C21.5523 16 22 15.5523 22 15V9C22 8.4477 21.5523 8 21 8H15ZM18 11C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13C17.4477 13 17 12.5523 17 12C17 11.4477 17.4477 11 18 11Z",
    fill: "#587594"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00195314 7C0.00175478 4.7909 1.79285 3 4.00195 3H18C19.5523 3 21 4.4477 21 6H15C13.3432 6 12 7.3431 12 9V15C12 16.6569 13.3431 18 15 18H21C21 19.5523 19.5523 21 18 21H4.00195C1.79265 21 0.00195314 19.2091 0.00195314 17V7ZM18 13C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11C17.4477 11 17 11.4477 17 12C17 12.5523 17.4477 13 18 13Z",
    fill: "#587594"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIco);
export default __webpack_public_path__ + "static/media/wallet-ico.a09f2e0c640ff7b61fe11bfef9be439c.svg";
export { ForwardRef as ReactComponent };